export default __webpack_public_path__ + "static/media/icon-caret-right.16fab993.svg";